// extracted by mini-css-extract-plugin
export default {"mainContainer":"users_mainContainer__pNPwh","mainContent":"users_mainContent__5JncY","table":"users_table__q4i6-","pagination":"users_pagination__6NbYQ"};